// Port of api/fuel/app/classes/filter/search/games/filters/post/rating/group/divisive.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
import Helpers from 'offline/filter/core/helpers'

export default {
	name: 'post.rating.group.divisive',
	priority: 60,
	post: true,
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && rangeActive(filter.rated && filter.rated.divisive, 0, 2)
	},
	run: function(config, filter, data, results) {
		if (!results.games || !results.games.length) return results
		var rows = DB.query('SELECT game_id, rating_value FROM rating WHERE game_id IN(' + Util.in(results.games) + ') AND user_id IN(' + Util.in(data.users) + ')')
		var byGame = {}
		for (var i = 0; i < rows.length; i++) {
			if (!byGame[rows[i].game_id]) byGame[rows[i].game_id] = []
			byGame[rows[i].game_id].push(parseFloat(rows[i].rating_value))
		}
		var validGames = {}
		var gameKeys = Object.keys(byGame)
		for (var g = 0; g < gameKeys.length; g++) {
			var ratings = byGame[gameKeys[g]]
			if (ratings.length < 2) continue
			var sorted = ratings.slice().sort(function(a,b) { return a - b })
			var mid = Math.floor(sorted.length / 2)
			var median = sorted.length % 2 ? sorted[mid] : (sorted[mid-1] + sorted[mid]) / 2
			var totalDiff = 0
			for (var r = 0; r < ratings.length; r++) totalDiff += Math.abs(ratings[r] - median)
			var diff = Math.round((totalDiff / ratings.length) * 100) / 100
			if (diff >= filter.rated.divisive.from && diff <= filter.rated.divisive.to) {
				validGames[gameKeys[g]] = true
			}
		}
		var newGames = results.games.filter(function(gid) { return validGames[gid] })
		results.games = Helpers.preserve_sort(results.games, newGames.map(function(id) { return { id: id } }), 'id').map(function(item) { return item.id })
		return results
	}
}
